module.exports = __webpack_public_path__ + "img/CS-Lite_Overview-Front_1.36f6aede.jpg";